import * as React from 'react';
import {
  DataGrid,
  GridActionsCellItem
} from '@mui/x-data-grid';

import api from "../../services/api";
import {
  Paper,
  Button,
  Typography,
} from '@mui/material';
import Grid from "@mui/material/Grid2";
import DeleteIcon from '@mui/icons-material/Delete';
import { useStoreActions } from 'easy-peasy';
import DialogoEmpresa from './DialogoEmpresa';
import { NoRowsOverlay } from '../../components';


const Empresas = () => {

  let startLoading = useStoreActions((actions) => actions.nav.startLoading);
  let stopLoading = useStoreActions((actions) => actions.nav.stopLoading);

  const [rows, setRows] = React.useState([]);
  const [openDlgEmpresa, setOpenDlgEmpresa] = React.useState(false);
  const [empresa, setEmpresa] = React.useState(null);

  const deleteEmpresa = React.useCallback((id) => async () => {
    startLoading();
    try {
      await api.http.delete('/empresas/' + id);
      stopLoading({ severity: 'success' });
      reloadEmpresas();
    } catch (error) {
      stopLoading({
        message: error.toString(),
        severity: 'error'
      });
    };
  }, []);

  const columns = React.useMemo(
    () => [{
      field: 'nome',
      headerName: 'Nome',
      flex: 5,
    }, {
      field: 'cnpj',
      headerName: 'CNPJ',
      flex: 1,
    }, {
      field: 'isMatriz',
      headerName: 'É Matriz?',
      flex: 1,
      valueGetter: (value) => {
        return value ? 'SIM' : 'NÃO';
      }
    },{
      field: 'actions',
      type: 'actions',
      headerName: 'Remover',
      width: 100,
      getActions: (params) => [
        <GridActionsCellItem
          icon={<DeleteIcon />}
          label="Delete"
          onClick={deleteEmpresa(params.id)}
        />
      ],
    }], [deleteEmpresa]
  );

  const adiciona = async () => {
    setOpenDlgEmpresa(true);
  };

  const onRowClick = (params, event, details) => {
    setEmpresa(params.row);
    setOpenDlgEmpresa(true);
  };

  const onCloseDlgEmpresa = (reload = false) => {
    setEmpresa(null);
    setOpenDlgEmpresa(false);
    if (reload) {
      reloadEmpresas();
    }
  };

  const reloadEmpresas = async (mount) => {
    startLoading();
    try {
      let empresas = (await api.http.get('/empresas')).data;
      if(!mount || mount.isMounted)
        setRows(empresas);
      stopLoading();
    } catch (error) {
      stopLoading({
        message: error.toString(),
        severity: 'error'
      });
    };
  };


  React.useEffect(() => {
    let mount = {
      isMounted: true,
    };
    reloadEmpresas(mount);
    return () => {
      mount.isMounted = false;
    };
  }, []);


  return (
    (<React.Fragment>
      <DialogoEmpresa
        open={openDlgEmpresa}
        onClose={onCloseDlgEmpresa}
        empresa={empresa} />
      <Grid container spacing={3} sx={{ 'my': 2 }}>
        <Grid style={{ 'textAlign': 'left' }} size="grow">
          <Typography variant="h4">Empresas</Typography>
        </Grid>
        <Grid style={{ 'textAlign': 'right' }} size="grow">
          <Button color="primary" variant="outlined" onClick={adiciona}>
            Adicionar empresa
          </Button>
        </Grid>
      </Grid>
      <Paper variant="elevation" elevation={2}
        style={{
          height: 400, width: '100%', marginBottom: 60
        }}>
        <DataGrid
          rows={rows}
          columns={columns}
          pageSize={5}
          rowsPerPageOptions={[5]}
          onRowClick={onRowClick}
          slots={{ noRowsOverlay: NoRowsOverlay }}
          disableSelectionOnClick />
      </Paper>
    </React.Fragment>)
  );
};

export default Empresas;
